import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { useDesktop } from "@/lib/useDesktop";

export default function Magnetic({ children, strength = 0.4, className = "" }) {
  const ref = useRef(null);
  const isDesktop = useDesktop();
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const onMove = (e) => {
    if (!isDesktop || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const mx = e.clientX - (rect.left + rect.width / 2);
    const my = e.clientY - (rect.top + rect.height / 2);
    setPos({ x: mx * strength, y: my * strength });
  };
  const reset = () => setPos({ x: 0, y: 0 });

  return (
    <motion.div
      ref={ref}
      className={className}
      onMouseMove={onMove}
      onMouseLeave={reset}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 200, damping: 15, mass: 0.3 }}
    >
      {children}
    </motion.div>
  );
}
